export default {
  disclaimerColor: 'var(--transparent-dark-grey-90)',
};
